import {Controller} from "@hotwired/stimulus"
import {Tooltip} from "bootstrap"

// Connects to data-controller="tooltip"
// Automatically initializes all Bootstrap tooltips within the controller's scope
export default class extends Controller {
    connect() {
        this.initializeTooltips()
    }

    disconnect() {
        this.destroyTooltips()
    }

    /**
     * Initialize all tooltips in the controller's scope
     */
    initializeTooltips() {
        this.tooltipElements = this.element.querySelectorAll('[data-bs-toggle="tooltip"]')

        this.tooltips = Array.from(this.tooltipElements).map(element => {
            // Check if HTML is explicitly enabled on this element
            const allowHtml = element.dataset.bsHtml === 'true'

            return new Tooltip(element, {
                trigger: 'hover focus',  // Show on hover and keyboard focus
                html: allowHtml,          // Only allow HTML if explicitly enabled
                delay: {show: 300, hide: 100}
            })
        })

        //console.log(`Initialized ${this.tooltips.length} tooltips`)
    }

    /**
     * Cleanup tooltips when controller disconnects
     */
    destroyTooltips() {
        if (this.tooltips) {
            this.tooltips.forEach(tooltip => tooltip.dispose())
            this.tooltips = []
        }
    }
}
